<template>
  <v-layout column>
    <!-- <v-flex headline primary--text ml-3 mb-3>{{ 'client_dashboard.token' | t }}</v-flex> -->
    <v-flex v-if="formload" text-md-center>
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-else>
      <v-layout row fill-height>
        <v-flex>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>info</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{'shop_ondemand.info.0' | t}}</v-list-tile-title>
                <v-list-tile-title>{{'shop_ondemand.info.1' | t}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-space-around row fill-height wrap>
        <v-flex
          xs12
          sm12
          md12
          lg5
          mt-3
          v-for="consumer of getMyConsumers.filter(x => x.api === 'digital' || x.api === 'youtube' )"
          :key="consumer.id"
        >
          <requests-selector :type="consumer.api"/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RequestsSelector from "@/components/RequestsSelector.vue";

export default {
  components: {
    RequestsSelector
  },
  data: () => ({
    formload: true
  }),
  computed: {
    ...mapGetters([
      "getServer",
      "getMyConsumers",
      "getUserId",
      "getTokenHeader"
    ])
  },
  methods: {
    ...mapActions(["setMyConsumers", "rmKey"])
  },
  created() {
    this.$http
      .get(
        `${this.getServer}/users/${this.getUserId}/consumers`,
        this.getTokenHeader
      )
      .then(data => {
        if (data.data) {
          const consumers = data.data.map(consumer => {
            if (consumer.api === "digital" && consumer.price === 0)
              consumer.price = 250 * 0.2;
            else if (consumer.api === "youtube" && consumer.price === 0)
              consumer.price = 250 * 0.2;
            else if (consumer.api === "facebook" && consumer.price === 0)
              consumer.price = 49.4 * 10;
            else if (consumer.api === "instagram" && consumer.price === 0)
              consumer.price = 49.4 * 10;
            else if (consumer.api === "twitter" && consumer.price === 0)
              consumer.price = 24.17 * 10;
            return consumer;
          });
          this.setMyConsumers(consumers);
          this.formload = false;
        }
      })
      .catch(() => {
        this.rmKey();
      });
  }
};
</script>